import React from 'react';
import PropTypes from 'prop-types';

import ChangeOfTenancyForm from './components/ChangeOfTenancyForm/ChangeOfTenancyForm';
import CumulativeBillingForm from './components/CumulativeBillingForm/CumulativeBillingForm';
import ChangeOfRegDetailsForm from './components/ChangeOfRegDetailsForm/ChangeOfRegDetailsForm';
import MeteringServiceChangeForm from './components/MeteringServiceChangeForm/MeteringServiceChangeForm';
import ConsumptionAmendmentForm from './components/ConsumptionAmendmentForm/ConsumptionAmendmentForm';
import DataServiceChangeForm from './components/DataServiceChangeForm/DataServiceChangeForm';
import ChangeOfEnergisationForm from './components/ChangeOfEnergisationForm/ChangeOfEnergisationForm';
import ChangeOfMeteringForm from './components/ChangeOfMeteringForm/ChangeOfMeteringForm';
import DisconnectionForm from './components/DisconnectionForm/DisconnectionForm';
import ChangeOfAnnualConsumptionForm from './components/ChangeOfAnnualConsumptionForm/ChangeOfAnnualConsumptionForm';
import ChangeOfSupplierForm from './components/ChangeOfSupplierForm/ChangeOfSupplierForm';
import ChangeOfCustomerContactDetailsForm from './components/ChangeOfCustomerContactDetails/ChangeOfCustomerContactDetailsForm';

import 'react-dates/lib/css/_datepicker.css';

/**
 * ProcessesDetail Component - Renders different process forms based on processDefinitionId
 */
const ProcessesDetail = ({ processDefinitionId, onClose, initialData }) => {
  // Route to appropriate form component based on process definition ID
  switch (processDefinitionId) {
    case 'changeOfTenancy':
      return <ChangeOfTenancyForm onClose={onClose} />;

    case 'cumulativeBillingProcess':
      return <CumulativeBillingForm processDefinitionId={processDefinitionId} onClose={onClose} />;

    case 'changeOfRegDetails':
      return <ChangeOfRegDetailsForm onClose={onClose} initialData={initialData} />;

    case 'meteringServiceChange':
      return <MeteringServiceChangeForm onClose={onClose} initialData={initialData} />;

    case 'consumptionAmendment':
      return <ConsumptionAmendmentForm onClose={onClose} initialData={initialData} />;

    case 'dataServiceChange':
      return <DataServiceChangeForm onClose={onClose} initialData={initialData} />;

    case 'changeOfEnergisation':
      return <ChangeOfEnergisationForm onClose={onClose} initialData={initialData} />;

    case 'changeOfMetering':
      return <ChangeOfMeteringForm onClose={onClose} initialData={initialData} />;

    case 'disconnection':
      return <DisconnectionForm onClose={onClose} initialData={initialData} />;

    case 'changeOfAnnualConsumption':
      return <ChangeOfAnnualConsumptionForm onClose={onClose} initialData={initialData} />;

    case 'changeOfSupplier':
      return <ChangeOfSupplierForm onClose={onClose} initialData={initialData} />;

    case 'changeOfCustomerContactDetails':
      return <ChangeOfCustomerContactDetailsForm onClose={onClose} initialData={initialData} />;
    

    default:
      return (
        <div>
          <p>Unknown process definition: {processDefinitionId}</p>
          <button onClick={onClose}>Cancel</button>
        </div>
      );
  }
};

ProcessesDetail.propTypes = {
  processDefinitionId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  initialData: PropTypes.object,
};

export default ProcessesDetail;
